module.exports = __webpack_public_path__ + "static/image/history/pc/201911@3x.jpg?e623c3b9";